import axios from "axios";
import { AccountInfo, PublicClientApplication} from "@azure/msal-browser";
import { APP_SETTINGS } from "../config/config";

const msalInstance = new PublicClientApplication(APP_SETTINGS.MSAL_CONFIG);

const api = axios.create({
  baseURL: "",
});

api.interceptors.request.use(
  async (config) => {
    if (
      config &&
      !config.url?.includes("login") &&
      !config.url?.includes("GetToken")
    ) {
      await msalInstance.initialize();
      const accounts: Array<AccountInfo> = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const scope: Array<string> = APP_SETTINGS.AUTH_CONFIG.authScopeRequests.scopes;
        try {
          const response = await msalInstance.acquireTokenSilent({
            scopes: scope,
            account: accounts[0],
          });
          console.log("Access token response", response);
          const bearer = `Bearer ${response.accessToken}`;
          // Add authentication headers to the request
          config.headers.Authorization = bearer;
        } catch (error) {
            console.error("Token acquisition failed. Logging out user.", error);
            msalInstance.logoutRedirect();
          return Promise.reject("Token acquisition failed");
        }
      } else {
        return Promise.reject(
          "No active account! Verify a user has been signed in."
        );
      }
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

export default api;
